'use strict';

var GridToolbarDataExtractCompletedDirective = function GridToolbarDataExtractCompletedDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmGridPanel',
    template: require('../templates/grid-toolbar-data-extract-completed.html'),
    controller: 'GridToolbarDataExtractCompletedController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarDataExtractCompletedDirective.$inject = [];
module.exports = GridToolbarDataExtractCompletedDirective;